import { Link } from 'react-router-dom';
import { Speaker, Home, ArrowLeft } from 'lucide-react';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background-light dark:bg-background-dark flex flex-col">
      {/* Header */}
      <header className="p-6">
        <Link to="/" className="flex items-center gap-2">
          <Speaker className="w-8 h-8 text-primary" />
          <span className="text-xl font-bold text-gray-900 dark:text-white">VoteBeats</span>
        </Link>
      </header>

      {/* Content */}
      <main className="flex-1 flex items-center justify-center p-6">
        <div className="text-center">
          {/* 404 Graphic */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-primary/20">404</h1>
            <div className="relative -mt-16">
              <div className="w-24 h-24 mx-auto bg-primary/10 rounded-full flex items-center justify-center">
                <Speaker className="w-12 h-12 text-primary" />
              </div>
            </div>
          </div>

          {/* Message */}
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-4">
            Page Not Found
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-md mx-auto mb-8">
            Looks like this track got lost in the mix. The page you're looking for
            doesn't exist or has been moved.
          </p>

          {/* Actions */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <button
              onClick={() => window.history.back()}
              className="btn btn-secondary inline-flex items-center"
            >
              <ArrowLeft className="w-5 h-5 mr-2" />
              Go Back
            </button>
            <Link to="/" className="btn btn-primary inline-flex items-center">
              <Home className="w-5 h-5 mr-2" />
              Back to Home
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="p-6 text-center text-sm text-gray-500 dark:text-gray-400">
        &copy; {new Date().getFullYear()} VoteBeats. All rights reserved.
      </footer>
    </div>
  );
}
